// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"ba86afff","787":"ba48f5ef"}[chunkId] + ".chunk.js";
};